// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__bffAy","pageSize":"DataTableRemotePaging_pageSize__n0QSP","selected":"DataTableRemotePaging_selected__NjUfJ"};